import React from "react";

import {
  DatePicker,
  Upload,
  Form,
  Input,
  Select,
  Button,
  Col,
  Row,
  Card,
  message,
} from "antd";

import PageHeading from "../../../components/common/PageHeading";
import Footer from "../../../components/common/Footer";
import { states } from "../../../utils/Util";
import BankAccounts from "../NewProperty/Components/BankAccounts";
import { DownloadOutlined, InboxOutlined } from "@ant-design/icons";
import RightBarMethod from "../../../components/common/RightBar/RightBarMethod";
import RightBar from "../../../components/common/RightBar";

const handleChange = () => {};

const { Dragger } = Upload;

const props = {
  name: "file",
  multiple: true,
  action: "https://www.mocky.io/v2/5cc8019d300000980a055e76",
  onChange(info) {
    const { status } = info.file;
    if (status !== "uploading") {
      console.log(info.file, info.fileList);
    }
    if (status === "done") {
      message.success(`${info.file.name} file uploaded successfully.`);
    } else if (status === "error") {
      message.error(`${info.file.name} file upload failed.`);
    }
  },
  onDrop(e) {
    console.log("Dropped files", e.dataTransfer.files);
  },
};

const NewAssociationsRightBar = [
  RightBarMethod(
    " HELP TOPICS",
    "t1",
    <i className="fa-solid fa-circle-question"></i>,
    [RightBarMethod("Import a New Association", "1", "", "", "")]
  ),
];

function NewAssociation() {
  return (
    <>
      <div className="page-container">
        <div className="main-container">
          <PageHeading heading="New Association" />

          <Form
            name="basic"
            labelCol={{ span: 7 }}
            initialValues={{ remember: true }}
            autoComplete="off"
            className="form-container"
            colon={false}
          >
            <Row>
              <Col span={24}>
                {/* PROPERY NAME AND ADDRESS CARD STARTS */}

                <Card title="Association Details" bordered={false}>
                  <Form.Item
                    name="associationName"
                    label="Association Name"
                    rules={[{ required: true }]}
                  >
                    <Input placeholder="My Association" />
                  </Form.Item>
                  <Form.Item
                    name="address"
                    label="Address"
                    rules={[{ required: true }]}
                  >
                    <Input placeholder="Address 1" />
                  </Form.Item>

                  <Form.Item label=" ">
                    <Input placeholder="Address 2" />
                  </Form.Item>

                  <Form.Item label="City">
                    <Row>
                      <Col flex={10}> 
                        <Input placeholder="City" />{" "}
                      </Col>
                      <Col flex={1}></Col>
                      <Col flex={2}>
                        <Select onChange={handleChange} options={states} />
                      </Col>
                      <Col flex={1}></Col>
                      <Col flex={2}>
                        <Input placeholder="Zip" />
                      </Col>
                    </Row>
                  </Form.Item>
                  <Form.Item label="Lockbox ID">
                    <Input placeholder="Optional" />
                  </Form.Item>
                </Card>

                <br />

                {/* BANK ACCOUNNTS CARD STARTS */}

                <BankAccounts />

                <br />

                {/* MONTHLY CHARGE SETTINGS */}

                <Card title="Monthly Charge Settings" bordered={false}>
                  <Row>
                    <Col flex={10}>
                      <Form.Item label="Start Date" labelCol={{ span: 4 }}>
                        <DatePicker style={{ width: "100%" }} placeholder="" />
                      </Form.Item>
                    </Col>
                    <Col flex={1}></Col>
                    <Col flex={13}>
                      <Form.Item label="GL Account" labelCol={{ span: 4 }}>
                        <Select
                          onChange={handleChange}
                          options={states}
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Card>

                <br />

                {/* IMPORT UNITS AND HOMEOWNERS SPREADSHEET */}

                <Card
                  title="Import Units and Homeowners Spreadsheet"
                  bordered={false}
                >
                  <p>
                    To upload unit and homeowner data, please download this
                    blank template file, and fill in the information for your
                    new association.
                  </p>

                  <p style={{ marginTop: 12 }}>
                    <b>For units with multiple homeowners: </b>enter each
                    homeowner on a new line, with the same unit information.
                    Once you've completed this spreadsheet, upload it here:
                  </p>

                  <Button style={{ marginTop: 12 }} icon={<DownloadOutlined />}>
                    Download Template
                  </Button>

                  <Dragger {...props} style={{ padding: 8, marginTop: 12 }}>
                    <InboxOutlined />
                    <span style={{ marginLeft: 8, fontSize: "16px" }}>
                      Drag files here or click to upload.
                    </span>
                  </Dragger>
                </Card>
              </Col>
            </Row>
          </Form>

          <Footer />
        </div>
      </div>

      <div className="RightSidebar">
        <RightBar RightBarData={NewAssociationsRightBar} />
      </div>
    </>
  );
}

export default NewAssociation;
